import http from '@/api/http'
import { API_BASE_URL } from '@/config/env'
import { adminList, adminRequest } from '@/entities/admin/api/adminRequest'
import {
  mapAdminOrderDetail,
  mapAdminOrderList,
} from '@/entities/order/model/mapAdminOrder'

const LIST_PATH = '/admin/orders'

export const ADMIN_ORDERS_PAGE_SIZE = 20

function hasAdminOrdersApi() {
  return Boolean(API_BASE_URL)
}

export async function fetchAdminOrdersApi({ limit = ADMIN_ORDERS_PAGE_SIZE, skip = 0, filter = {},
  sort = {} } = {}) {
    if (!hasAdminOrdersApi()) {
      return { items: [], total: 0 }
    }
  
    const payload = await adminList(LIST_PATH, {
      limit,
      skip,
      filter,
      sort,
    })

  const list = mapAdminOrderList(payload.data)
  return {
    items: list,
    total: Number(payload.total) || list.length,
  }
}

export async function fetchAdminOrderByIdApi(orderId) {
  if (!orderId || !hasAdminOrdersApi()) {
    return null
  }

  const payload = await adminRequest(() => http.get(`/admin/order/${orderId}`))
  return mapAdminOrderDetail(payload.data)
}

function resolveAdminOrderActionPath(path, orderId) {
  return String(path ?? '').replace(':id', encodeURIComponent(String(orderId)))
}

export async function executeAdminOrderActionApi(orderId, action, body = {}) {
  if (!orderId || !action?.path || !hasAdminOrdersApi()) {
    return null
  }

  const method = String(action.method ?? 'POST').toUpperCase()
  const path = resolveAdminOrderActionPath(action.path, orderId)

  if (method !== 'POST') {
    throw new Error(`Unsupported admin order action method: ${method}`)
  }

  const payload = await adminRequest(() => http.post(path, body))
  return mapAdminOrderDetail(payload.data)
}
